export default __webpack_public_path__ + "static/media/google.212dec99.png";